class ShopByLook extends HTMLElement {
  #controller = null;
  #visible = 0;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();

    requestAnimationFrame(() => {
      if (!this.isConnected || !this.#controller) return;
      this.#bind();
    });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
  }

  #bind() {
    const { signal } = this.#controller;
    const cards = [...this.querySelectorAll('.shop-by-look__card')].sort(
      (a, b) => Number(a.dataset.sblIndex) - Number(b.dataset.sblIndex)
    );
    const loadMore = this.querySelector('[data-sbl-load-more]');
    const popup = this.querySelector('dialog-component.shop-by-look-popup');
    const popupBody = popup?.querySelector('[data-sbl-popup-body]');

    const desktopInitial = Number(this.dataset.sblInitial) || 12;
    const mobileInitial = Number(this.dataset.sblInitialMobile) || 8;
    const step = Number(this.dataset.sblStep) || 8;
    const initial = window.innerWidth < 750 ? mobileInitial : desktopInitial;

    this.#visible = Math.min(initial, cards.length);

    const render = () => {
      cards.forEach((card, index) => {
        card.hidden = index >= this.#visible;
      });
      if (!loadMore) return;
      loadMore.hidden = this.#visible >= cards.length;
      const wrap = loadMore.closest('.shop-by-look__more');
      if (wrap) wrap.hidden = loadMore.hidden;
    };

    loadMore?.addEventListener(
      'click',
      () => {
        this.#visible = Math.min(this.#visible + step, cards.length);
        render();
      },
      { signal }
    );

    sblDesktopMq.addEventListener(
      'change',
      () => {
        if (popupBody?.childElementCount) layoutShopByLookSizeGuides(popupBody);
      },
      { signal }
    );

    this.addEventListener(
      'click',
      (event) => {
        const plus = event.target.closest('[data-sbl-open]');
        if (!plus) return;

        event.preventDefault();
        event.stopPropagation();
        if (!popup || !popupBody) return;

        const template = this.querySelector(`#sbl-look-${plus.getAttribute('data-sbl-open')}`);
        if (!template) return;

        popupBody.replaceChildren(template.content.cloneNode(true));
        layoutShopByLookSizeGuides(popupBody);
        customElements.whenDefined('dialog-component').then(() => popup.showDialog?.());
      },
      { signal }
    );

    render();
  }
}

const sblDesktopMq = window.matchMedia('(min-width: 750px)');

/** @param {ParentNode} root */
function layoutShopByLookSizeGuides(root) {
  root.querySelectorAll('bundle-product-slot').forEach((slot) => {
    const guide = slot.querySelector('.bundle-size-guide');
    const mutable = slot.querySelector('[data-bundle-slot-mutable]');
    if (!guide || !mutable) return;
    if (guide.parentElement !== mutable) {
      mutable.appendChild(guide);
    }
  });
}

if (!customElements.get('shop-by-look')) {
  customElements.define('shop-by-look', ShopByLook);
}
